

type Props = {
    id: string;
    shortDescription: string;
    description: string;
    isTextHolderWithBG: boolean;
    isTextCentered: boolean;
};

const TextHolderContentDescription: React.FC<Props> = ({ isTextCentered, shortDescription, id, description, isTextHolderWithBG }) => {


    return (

        <div className={`d-md-block arimo ${isTextCentered ? 'mst-center-justfy-text': ''} content-txt  mb-4`}>

            {
                shortDescription &&

                <div dangerouslySetInnerHTML={{ __html: shortDescription }}>
                </div>
            }

            <div id={"whrapper-collapseAbout-" + id}>

                <div
                    id={"collapseAbout-" + id}
                    dangerouslySetInnerHTML={{ __html: description }}
                    className={`
                        mb-2 arimo content-txt mst-print-show 
                        ${isTextHolderWithBG ? '' : "collapse"}
                    `}>

                </div>

            </div>

        </div>

    )

}

export default TextHolderContentDescription;